import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  button: false,
  sidemenu: false,
};

const navReducerFunction = createSlice({
  name: "navbar",
  initialState,
  reducers: {
    toggle: (state) => {
      state.button = !state.button;
    
    },
    dropdown: (state) => {
      state.sidemenu =!state.sidemenu;
    },
  },
});

export const { toggle,dropdown } = navReducerFunction.actions;

export default navReducerFunction.reducer;
